import { ConceptModelGen } from '../services/parser/concept-model-gen';
import { ModelSerializationUtils } from '../utils/model-serialization-utils';

/**
 * Calculates the ConceptModel from the ComponentModel. This will either be called from a web-worker or the test cases.
 */
export class ConceptModelWorkerProxy {
  /**
   * Concept-Model calculation can either happen inside the Web-Worken when available (Browser) or in the jest-tests.
   * The generation logic is inside the proxy function, which takes the addEventListener and postMessage function from the Web-Worker. The jest-impl provides proxy methods to do the same thing.
   * @param addEventListener method which accepts a function with an event and callback. The worker will just pass its addEventListener function. The jest implementation is registering an internal method.
   * @param postMessage method for posing the results to. The web-worker will use it's native postMessage function. The jest implementation is just a proxy for the onmessage function.
   */
  public static proxy(
    addEventListener: (eventName: string, fn: (event: MessageEvent) => void) => void,
    postMessage: (message: any, options?: WindowPostMessageOptions) => void
  ) {
    addEventListener('message', event => {
      const [fieldsDocument, activeLanguages, componentModel] = event.data;

      var parsedComponentModel = ModelSerializationUtils.deserializeComponentModel(componentModel);
      const conceptModelGen = new ConceptModelGen(fieldsDocument, activeLanguages);
      const createdModel = conceptModelGen.createConceptModel(parsedComponentModel);

      postMessage(createdModel);
    });
  }
}
